import * as Icons from "@nova/component-icons"
import { ContextMenuItem } from "features/data-management/workspace/TODO-put-in-package/ContextMenu"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { LayerPluginSpec } from "plugins/plugin-registry"
import { removeLayerFromSelection, selectSelectedLayerIds, setRenamingLayerId } from "../slice.new"
import { useMapActions } from "./genericContextMenuSections"
import {
    getGenericConfirmationModalComponent,
    useConfirmationModalContext,
} from "features/modals/WorkspaceConfirmationModalV2"
import { useArchiveContextMenuOption } from "./useArchiveContextMenuOption"
import { useIsEditor } from "tools/hooks/useIsEditor"

export function getUseAssetsContextMenuSections(spec: LayerPluginSpec) {
    return function useAssetsContextMenuSections(id: string) {
        const dispatch = useAppDispatch()
        const entity = useAppSelector(spec.selectSingleEntity(id))
        const confirmationModal = useConfirmationModalContext()
        const selectedLayerIds = useAppSelector(selectSelectedLayerIds)
        const isEditor = useIsEditor()
        const actions = [] as ContextMenuItem[][]
        if (isEditor) {
            actions.push([
                {
                    title: "Rename",
                    onClick: () => {
                        dispatch(setRenamingLayerId({ id }))
                    },
                    Icon: Icons.Pencil,
                },
            ])
        }
        const mapActions = useMapActions({
            spec,
            id,
        })
        actions.push(mapActions)
        const archiveOption = useArchiveContextMenuOption(id)
        if (archiveOption) {
            actions.push([archiveOption])
        }
        if (isEditor) {
            actions.push([
                {
                    title: "Delete",
                    onClick: async () => {
                        if (spec.confirmDelete(entity)) {
                            const didConfirm = await confirmationModal.confirm({
                                RenderComponent: getGenericConfirmationModalComponent({
                                    title: "Delete Selection?",
                                    message: `This will delete ${entity.name}, do you want to proceed?`,
                                }),
                            })
                            if (!didConfirm) return
                        }
                        dispatch(spec.deleteAction({ id }))
                        if (selectedLayerIds.includes(id)) {
                            dispatch(removeLayerFromSelection({ id }))
                        }
                    },
                    Icon: Icons.Trash,
                    isDestructive: true,
                },
            ])
        }
        return actions
    }
}
